import PropTypes from 'prop-types';

/**
 * Business idea definition
 */
export const BusinessEntityAdvisor = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  // category: PropTypes.string,
  report: PropTypes.oneOfType([
    // Future backend structure with sections array
    PropTypes.shape({
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          content: PropTypes.string.isRequired
        })
      )
    }),
    // Current flat structure (flexible - can have any report fields)
    PropTypes.object
  ]),
  businessPlan: PropTypes.object
});

/**
 * User profile from ChoiceFlow answers
 */
export const UserProfile = PropTypes.shape({
  preferences: PropTypes.object,
  answers: PropTypes.object.isRequired
});

/**
 * Business results data structure
 * Supports either 'ideas' or 'items' array (one is required)
 * @param {object} props - Component props
 * @param {string} propName - Property name
 * @param {string} componentName - Component name
 * @returns {Error|null} Error if validation fails, null otherwise
 */
export const BusinessEntityAdvisorResultsData = (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment -- Dynamic property access required for PropType validator
  const data = props[propName];

  if (!data) {
    return new Error(`The prop '${propName}' is required in '${componentName}'.`);
  }

  const hasIdeas = Array.isArray(data.ideas) && data.ideas.length > 0;
  const hasItems = Array.isArray(data.items) && data.items.length > 0;

  if (!hasIdeas && !hasItems) {
    return new Error(
      `The prop '${propName}' in '${componentName}' must have either 'ideas' or 'items' array with at least one element.`
    );
  }

  return null;
};

/**
 * Main BusinessResults props
 */
export const BusinessEntityAdvisorResultsProps = PropTypes.shape({
  data: BusinessEntityAdvisorResultsData,
  onEmailReport: PropTypes.func,
  onGenerateMore: PropTypes.func,
  onIdeaSelect: PropTypes.func
});
